/*eslint "no-console": "off"*/
import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import {ApolloProvider, ApolloClient, ApolloLink} from '@apollo/client';
import {InMemoryCache} from '@apollo/client/cache';
import {createUploadLink} from 'apollo-upload-client';
import {onError} from '@apollo/client/link/error';
import FormContainer from './views/form';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import Modal from 'react-modal';
import {QueryParamProvider} from 'use-query-params';
import * as Sentry from '@sentry/react';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.NODE_ENV,
  });
}

const link = createUploadLink({
  uri: '/graphql',
  credentials: 'include',
}) as unknown as ApolloLink;

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({graphQLErrors, networkError}) => {
      if (graphQLErrors)
        graphQLErrors.map(({message, locations, path}) => {
          const msg = `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`;
          console.log(msg);
          Sentry.captureMessage(msg);
        });
      if (networkError) console.log(`[Network error]: ${networkError}`);
    }),
    link,
  ]),
  cache: new InMemoryCache(),
});

require('moment/locale/ja');
moment.locale('ja');
Modal.setAppElement('#app');

const App = () => (
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <ApolloProvider client={client}>
      <Router>
        <QueryParamProvider ReactRouterRoute={Route}>
          <FormContainer />
        </QueryParamProvider>
      </Router>
    </ApolloProvider>
  </Sentry.ErrorBoundary>
);

export default App;

ReactDOM.render(<App />, document.getElementById('app'));
